<template>
  <div class="container mt-2">
    <h4 class="">
      {{ title }}
      <small class="text-danger text-tiny"> ** สามารถตอบได้มากกว่า 1 รายการ</small>
    </h4>
    <b-row>
      <b-col
        v-for="(box, index) in selects"
        :key="index"
        cols="4"
        class="mt-1"
      >
        <b-form-checkbox
          :key="index"
          v-model="box.checked"
          @change="checkboxChanged"
        >
          {{ box.text }}
        </b-form-checkbox>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
} from 'bootstrap-vue'
// import { required, email } from '@validations'
import Personal from './Personal.vue'

export default {
  components: {
    // ValidationProvider,
    // ValidationObserver,
    // FormWizard,
    // TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    // vSelect,
    // BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    Personal,
  },
  props: {
    selects: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  created() {
    // `this` points to the vm instance
    // console.log(`custom group a is: ${this.a}`)
    // console.log('this.selects', this.selects)
  },
  methods: {
    checkboxChanged() {
      // console.log(this.selects)
    },
  },
}

</script>

<style>

</style>
